export default __webpack_public_path__ + "static/media/bg-image-landing.4b3b03ae.jpg";